import React from "react";
import styled from "styled-components";

const Wrapper = styled.ol`
	margin-bottom: 60px;
	list-style-type: none;

	@media (max-width: 576px) {
		padding: 10px;
	}

	li {
		display: flex;
		margin-bottom: 30px;
	}

	li:before {
		content: counter(numbered-list);
		font-size: 40px;
		font-weight: bold;
		color: #01788a;
		margin-top: -7px;
		margin-right: 15px;
		font-family: "Cera Basic";
	}
`;

const Item = styled.li`
	counter-increment: numbered-list;
	margin: 10px auto 10px auto;
	font-family: "Cera Basic";
	font-size: 15px;
`;

const NumberedList = ({ children }) => (
	<Wrapper>
		{children.map((item) => (
			<Item>{item}</Item>
		))}
	</Wrapper>
);

export default NumberedList;
